export default "__VITE_ASSET__ec0035f5__"